import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { languageList } from 'src/app/config/language.config';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  currentLanguage = new BehaviorSubject('en');
  languages = languageList;
  constructor(private router: Router) { }

  execute(): void {
    const hash = location.hash;
    const slashHash = hash.split('/');
    const urlLang = slashHash[1];
    const lang = this.languages.find((index) => index === urlLang) || 'en';
    this.setLanguage(lang);
  }

  setLanguage(lang: string): void {
    this.currentLanguage.next(lang);
    this.router.navigate([lang]);
  }
}
